export enum OrdersQueryKeys {
  GET_ORDERS_LIST = 'GET_ORDERS_LIST',
}
